module.exports = __webpack_public_path__ + "img/choose-up-13_4 virtual.a7e83cd6.png";